import { Link } from "react-router-dom";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import ServiceHighlights from "../components/ServiceHighlights";
import ServicesOverview from "../components/ServicesOverview";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import PartnerMarquee from "../components/PartnerMarquee";
import HelpButton from "../components/HelpButton";
import ActivationSteps from "../components/ActivationSteps";
import { Check, Phone } from "lucide-react";
import { Reviews } from "../components/Reviews";
import SEO from "../components/SEO";
import { generateServiceSchema } from "../lib/schema";

function Groepenkast() {
  return (
    <div className="min-h-screen bg-gray-50 page-transition pt-[99px] md:pt-[133px]">
      <Header />
      <SEO
        title="Groepenkast vervangen"
        description="Laat uw groepenkast vakkundig vervangen of uitbreiden door onze gecertificeerde elektriciens. Vraag direct een vrijblijvende offerte aan."
        schema={generateServiceSchema({
          name: "Groepenkast vervangen",
          description:
            "Professionele groepenkast vervanging en uitbreiding. Vakkundige installatie volgens NEN 1010 normen.",
          image: "https://elektraaanleggen.nl/images/banner.png",
        })}
      />

      <HeroSection
        title="Groepenkast vervangen"
        description="Laat uw groepenkast vakkundig vervangen of uitbreiden door onze gecertificeerde elektriciens. Vraag direct een vrijblijvende offerte aan."
        imageSrc="/images/uitbr.png"
      />

      {/* Features Section */}
      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] mb-12 md:mb-16">
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Groepenkast vervangen – Kies voor veiligheid en betrouwbaarheid!
            </h2>
            <div className="mb-6">
              <p className="text-[#17354A] font-medium mb-4">
                Een goed werkende groepenkast is de ruggengraat van uw
                elektrische installatie. Als uw groepenkast verouderd is of niet
                meer voldoet aan de huidige eisen, kan dat storingen,
                overbelasting of zelfs brandgevaar veroorzaken. Vooral bij het
                gebruik van moderne apparaten zoals inductiekookplaten,
                laadpalen en zonnepanelen, is het essentieel dat uw groepenkast
                voldoende capaciteit heeft en veilig functioneert. Bij Elektra
                Aanleggen begrijpen we hoe belangrijk een stabiele en veilige
                elektriciteitsvoorziening is. Daarom werken wij uitsluitend met
                hoogwaardige materialen en A-merk componenten, zoals ABB
                groepenkasten. ABB staat bekend om zijn betrouwbare, duurzame en
                hoogwaardige elektrische componenten, die voldoen aan de
                strengste veiligheidseisen. Met een ABB groepenkast bent u
                verzekerd van een veilige en efficiënte stroomverdeling,
                geschikt voor zowel particuliere als zakelijke toepassingen. Of
                u nu een oude stoppenkast wilt vervangen door een moderne
                groepenkast, extra groepen nodig heeft voor uw inductiefornuis,
                of uw installatie wilt uitbreiden naar een 3-fase aansluiting,
                wij regelen het vakkundig en snel. Onze gecertificeerde
                elektriciens zorgen ervoor dat uw nieuwe groepenkast volledig
                wordt geïnstalleerd volgens de NEN 1010 & NEN 3140 normen, zodat
                uw elektrische installatie toekomstbestendig en veilig is.
              </p>
            </div>

            <div className="h-6"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Direct Gratis Offerte
                </span>
              </Link>
              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />: 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <span className="absolute bg-[#17354A] text-white px-2 py-1 text-xs rounded-md opacity-20 top-1/4 right-1/3">
                elektraaanleggen.nl
              </span>
              <img
                alt="3-fase aansluiting"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/ABB-440x390-3F.png"
              />
            </div>
          </div>
        </div>

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-1">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Wat kost het vervangen van een groepenkast?
            </h2>
            <div className="mb-6">
              <p className="text-[#17354A] font-medium mb-4">
                Bij het Elektra Aanleggen hanteren wij altijd een vaste prijs
                vooraf, geheel vrijblijvend.
              </p>

              <p className="text-[#17354A] font-medium mb-4">
                De kosten starten <strong>vanaf €450 </strong>, afhankelijk van
                factoren zoals:
              </p>

              <ul className="space-y-3 mb-6">
                <li className="flex items-center gap-2">
                  <Check className="w-5 h-5 text-[#F47B20]" />
                  <span className="text-[#17354A]">
                    Aantal groepen – Meer apparaten betekent meer groepen om
                    overbelasting te voorkomen
                  </span>
                </li>
                <li className="flex items-center gap-2">
                  <Check className="w-5 h-5 text-[#F47B20]" />
                  <span className="text-[#17354A]">
                    1-fase of 3-fase aansluiting – 3-fase is nodig voor zware
                    apparaten zoals een warmtepomp of laadpaal
                  </span>
                </li>
                <li className="flex items-center gap-2">
                  <Check className="w-5 h-5 text-[#F47B20]" />
                  <span className="text-[#17354A]">
                    Extra uitbreidingen – Zoals extra groepen voor inductie,
                    zonnepanelen of een laadpaal
                  </span>
                </li>
              </ul>

              <p className="text-[#17354A] font-medium mb-4">
                Bij Elektra Aanleggen krijgt u altijd vooraf een vaste prijs,
                zodat u niet voor verrassingen komt te staan. Wij sturen u
                binnen 24 uur een vrijblijvende offerte, zodat u precies weet
                waar u aan toe bent. Onze ervaren elektriciens zorgen ervoor dat
                de installatie vaak binnen één werkdag volledig geregeld is.
                Bovendien bieden wij 8 jaar garantie op zowel materiaal als
                installatie.
              </p>
            </div>

            <div className="h-6"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Direct Gratis Offerte
                </span>
              </Link>
              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />: 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:order-2">
            <div className="relative">
              <span className="absolute bg-[#17354A] text-white px-2 py-1 text-xs rounded-md opacity-20 top-1/4 right-1/3">
                elektraaanleggen.nl
              </span>
              <img
                alt="3-fase aansluiting"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/mtrkast.png"
              />
            </div>
          </div>
        </div>
        <ActivationSteps />

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-1">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Groepenkast upgraden naar 3-fase – Meer vermogen, klaar voor de
              toekomst!
            </h2>
            <div className="mb-6">
              <p className="text-[#17354A] font-medium mb-4">
                Steeds meer huishoudens en bedrijven stappen over op
                energiezuinige en krachtige elektrische apparaten. Denk aan
                inductiekookplaten, laadpalen, warmtepompen en
                airconditioningsystemen. Deze apparatuur verbruikt aanzienlijk
                meer stroom, waardoor een 1-fase groepenkast vaak niet meer
                voldoende is. Dit kan leiden tot storingen, overbelasting, of
                uitvallende groepen, vooral wanneer meerdere apparaten
                tegelijkertijd worden gebruikt. De oplossing? Een upgrade naar
                een 3-fase groepenkast. Met een 3-fase aansluiting wordt de
                stroom gelijkmatiger verdeeld, waardoor uw installatie stabiel
                en veilig blijft functioneren. Dit is niet alleen essentieel om
                stroomstoringen te voorkomen, maar ook om uw woning of bedrijf
                toekomstbestendig te maken voor verdere uitbreiding met
                bijvoorbeeld zonnepanelen of extra elektrische apparaten.
              </p>
              <ul className="space-y-3">
                <li className="flex items-center gap-2">
                  <Check className="w-5 h-5 text-[#F47B20]" />
                  <span className="text-[#17354A]">
                    Gratis online inspectie – Wij analyseren uw huidige situatie
                    en bepalen de beste oplossing
                  </span>
                </li>
                <li className="flex items-center gap-2">
                  <Check className="w-5 h-5 text-[#F47B20]" />
                  <span className="text-[#17354A]">
                    Duidelijke offerte vooraf – Altijd een vaste prijs, zonder
                    verborgen kosten
                  </span>
                </li>
                <li className="flex items-center gap-2">
                  <Check className="w-5 h-5 text-[#F47B20]" />
                  <span className="text-[#17354A]">
                    Professionele installatie – Onze gecertificeerde
                    elektriciens installeren uw nieuwe 3-fase groepenkast
                    volgens de nieuwste normen
                  </span>
                </li>

                <li className="flex items-center gap-2">
                  <Check className="w-5 h-5 text-[#F47B20]" />
                  <span className="text-[#17354A]">
                    Oplevering & controle – Wij testen de installatie, zorgen
                    voor een correcte werking en geven u een duidelijke uitleg
                  </span>
                </li>
              </ul>
            </div>
            <div className="h-6"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Direct Gratis Offerte
                </span>
              </Link>
              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />: 085-2129778
                </span>
              </a>
            </div>
          </div>

          <div className="order-1 md:order-2">
            <div className="relative">
              <span className="absolute bg-[#17354A] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektraaanleggen.nl
              </span>

              <img
                alt="3-fase aansluiting"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/3fase.png"
              />
            </div>
          </div>
        </div>

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Groepenkast uitbreiden: klaar voor de toekomst
            </h2>
            <div className="mb-6">
              <p className="text-[#17354A] font-medium mb-4">
                Heeft u steeds meer elektrische apparaten in huis of op uw
                bedrijfslocatie en merkt u dat uw huidige groepenkast niet meer
                voldoende capaciteit heeft? Dan is het uitbreiden van uw
                groepenkast een slimme keuze. Een goed ingerichte en
                toekomstbestendige groepenkast zorgt ervoor dat uw elektrische
                installatie veilig en betrouwbaar blijft werken, zonder risico
                op overbelasting. Bij Elektra Aanleggen helpen we u graag met
                een deskundige en efficiënte uitbreiding van uw groepenkast. Of
                het nu gaat om extra groepen voor een inductiekookplaat,
                laadpaal, zonnepanelen of een nieuwe keuken, wij zorgen ervoor
                dat uw elektrische installatie klaar is voor de toekomst. Bent u
                benieuwd hoe een groepenkast uitbreiding werkt en welke
                mogelijkheden het beste bij uw situatie passen? Neem
                vrijblijvend contact met ons op voor advies en een offerte op
                maat. Onze specialisten leggen u alles duidelijk uit en zorgen
                voor een veilige en professionele installatie.
              </p>
            </div>

            <div className="h-6"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Direct Gratis Offerte
                </span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <span className="absolute bg-[#17354A] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektraaanleggen.nl
              </span>
              <img
                alt="Kookgroep installatie"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/abb_1spf006972f0086_groepenkast.jpg"
              />
            </div>
          </div>
        </div>
      </section>

      <ServicesOverview />
      <FAQ />

      <ServiceHighlights />

      <Reviews />
      <PartnerMarquee />

      {/* CTA Section */}
      <div className="w-full cursor-pointer bg-[#2FB6D2] transition-opacity duration-150 hover:opacity-80">
        <Link
          to="/offerte"
          aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
        >
          <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] text-center py-6 justify-between items-center">
            <div
              data-variant="h2"
              className="font-bold leading-[1.25] text-[28px] lg:text-[36px] self-center text-white mb-0"
            >
              Gratis offerte
            </div>
          </section>
        </Link>
      </div>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default Groepenkast;
